<template>
  <div>
    <div class="page cover html2pdf__page-break">
      <h1>リハビリ履歴表示</h1>
      <div class="info">
        <p>名前 : {{ user && user.information ? user.information.fullname : "" }}</p>
        <p>ID : {{ user.patient_id }}</p>
        <p>性別 : {{user.information && user.information.sex === 0 ? "女性" : user.information && user.information.sex === 1 ? "男性" : "無回答" }}</p>
      </div>
    </div>

    <div class="page">
      <table>
        <thead>
        <tr>
          <th class="col">実施した日</th>
          <th class="col">メニュー</th>
          <th class="col">タイトル</th>
          <th class="col">実施回数</th>
          <th class="col">痛みの有無</th>
          <th class="col">実施時間</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items" :key="item.id">
          <td>{{ item.tested_at | fomatDate2 }}</td>
          <td>{{ item.rehab_video_suggestion_title }}</td>
          <td>{{ item.rehab_video?.name }}</td>
          <td>{{ item.count }}</td>
          <td>{{ item.pain_title }}</td>
          <td>{{ formatTime(item.tested_at) }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {filter} from "../../helpers/Vue-Filter";
import moment from 'moment';

export default {
  filters: {
    ...filter,
  },
  props: ["items", "user"],
  methods: {
    formatTime(datetime) {
      return moment(new Date(datetime)).format('HH時mm分')
    },
  }
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  padding: 40px;
  text-align: center;
}

.cover {
  position: relative;
}

h1 {
  margin-top: 350px;
  font-size: 36px;
  font-weight: 500;
  color: #000;
}

.info {
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  margin-top: 350px;
  color: #000;
  position: absolute;
  left: 70px;
  top: 500px;
}

table {
  border-collapse: collapse;
  width: 100%;
}

thead {
  tr {
    background-color: #eee; font-weight: bold
  }
}

tbody {
  tr:nth-child(even) {background-color: #f2f2f2;}
}

th, td {
  text-align: left;
  padding: 8px;
  color: #000;
}

</style>
